import * as Solr from "../../../3x1010/Solr.js";
import VirtualList from "../../../components/common/VirtualList.component.js";
import QueryBuilder from "./QueryBuilder.js";

export default class NodeBoolean {
  constructor(type, schema, collection, template, target, level, node, parent, callback) {
    this.type = type;
    this.schema = schema;
    this.collection = collection;
    this.template = template;
    this.target = parent ? jQuery(target, parent) : target;
    this.level = level;
    this.node = node;
    this.parent = parent;
    this.callback = callback;
    this.mc = null;
    this.actionsArea = null;
    this.buttonsArea = null;
    this.btnDelete = null;
    this.btnAddBoolean = null;
    this.btnAddTerm = null;
    this.btnExists = null;
    this.btnAnd = null;
    this.btnOr = null;
    this.btnNot = null;
    this.collections = this.schema.getCollectionNames(true);
    console.log(this.collections);
  }

  init() {
    if (this.type === QueryBuilder.QUERY_BIANCA) {
      this.buildBianca();
    } else if (this.type === QueryBuilder.QUERY_NERA) {
      this.buildNera();
    }
  }

  dispose() {
    this.mc.remove();
  }

  buildNera() {
    // Crea il clip
    this.mc = jQuery(this.template).clone();
    this.mc.attr("id", this.node.id);
    this.target.append(this.mc);
    // Definisce le aree
    this.actionsArea = this.mc.find("> .js-actions");
    this.buttonsArea = this.actionsArea.find("> .js-buttons");

    // Setta il path
    jQuery(".js-path", this.actionsArea).text(this.node.Field._label);

    if (this.node.Field._label !== "/") {
      const props = [];
      if (this.node.Field.Relation) {
        props.push("relazione");
      } else if (this.node.Field.Type == Solr.FieldType.ComplexField) {
        props.push("entità");
      } else if (this.node.Field.Type == Solr.FieldType.StrField) {
        props.push("case sensitive");
      } else if (this.node.Field.Lookup) {
        props.push("lemmario");
      }
      for (let x = 0; x < props.length; x++) {
        const prop = jQuery("#template-property").clone();
        prop.removeAttr("id");
        prop.text(props[x]);
        jQuery(".js-properties", this.mc).append(prop);
      }
    }

    // Per comodità definisce i pulsanti
    this.btnDelete = jQuery(".js-cta-delete", this.buttonsArea);
    this.btnAddBoolean = jQuery(".js-cta-add-boolean", this.actionsArea);
    this.btnAddTerm = jQuery(".js-cta-add-term", this.actionsArea);
    this.btnExists = jQuery(".js-cta-exists", this.actionsArea);
    this.btnAnd = jQuery(".js-cta-and", this.actionsArea);
    this.btnOr = jQuery(".js-cta-or", this.actionsArea);
    this.btnNot = jQuery(".js-cta-not", this.actionsArea);

    if (this.level === 0) {
      // Se è il nodo radice, nasconde il pulsante "rimuovi"
      this.btnDelete.hide();
      // Se è il nodo radice, nasconde il pulsante "exists"
      this.btnExists.hide();
      // Scrive il nome della collection
      const vsct = this.mc.find("> .js-collection").find("> .js-collection-name");

      const list = [];
      for (let x = 0; x < this.collections.length; x++) {
        list.push({
          id: this.collections[x],
          label: this.collections[x].split("_")[0],
        });
      }
      // Sorta su label
      list.sort((a, b) => {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      });

      this.vSelect = new VirtualList(vsct[0], {
        options: list,
        entryHeight: 30,
        valueKey: "id",
        labelKey: "label",
        isSelect: true,
        callback: this.handleSelectEvs.bind(this),
      });
      this.vSelect.init();
      this.vSelect.value = this.collection;
    } else {
      // Controlla se deve mostrare il pulsante exists o no
      if (!this.node.AdmitExists) {
        this.btnExists.hide();
      }
      // Toglie la riga della collection
      this.mc.find("> .js-collection").hide();
    }

    if (this.level % 2 === 0) {
      this.mc.addClass("has-bg-light");
    }

    // Crea le call to action
    this.createActions();
  }

  handleSelectEvs(e) {
    switch (e.type) {
      case "change":
        this.dispatch(QueryBuilder.EVENT_CHANGE_COLLECTION, this.vSelect.value);
        break;
    }
  }

  createActions() {
    // Add boolean
    this.btnAddBoolean.on("click", this.onAddBoolean.bind(this));
    // Add term
    this.btnAddTerm.on("click", this.onAddTerm.bind(this));

    // Remove
    this.btnDelete.on("click", this.onRemove.bind(this));

    // Inizializza il blocco exits and e or
    this.initExistsAndOrNot();
  }

  onAddBoolean() {
    this.dispatch(QueryBuilder.EVENT_ADD_BOOLEAN, this);
  }

  onAddTerm() {
    this.dispatch(QueryBuilder.EVENT_ADD_TERM, this);
  }

  onRemove() {
    this.dispatch(QueryBuilder.EVENT_REMOVE_BOOLEAN, this);
  }

  getInner() {
    return this.mc.find("> .js-inner");
  }

  initExistsAndOrNot() {
    // Exists
    this.btnExists.on("click", this.onExists.bind(this, true));
    // And
    this.btnAnd.on("click", this.onAnd.bind(this, true));
    // Or
    this.btnOr.on("click", this.onOr.bind(this, true));
    // Not
    this.btnNot.on("click", this.onNot.bind(this, true));

    // Seleziona quello attualmente selezionato
    if (this.node.Operator === Solr.QueryNodeBooleanType.AND) {
      this.onAnd(false);
    } else if (this.node.Operator === Solr.QueryNodeBooleanType.OR) {
      this.onOr(false);
    } else {
      this.onExists(false);
    }

    // Per il not la gestione è diversa perché può essere attivo o disattivo indipendentemente dagli altri
    if (this.node.Occurency === Solr.QueryNodeOccurencyType.NOT) {
      this.onNot(false);
    }

    if (QueryBuilder.SIMPLE_MODE) {
      this.btnNot.hide();
      if (this.node.AdmitExists) {
        this.btnOr.hide();
        this.btnAnd.hide();
      }
    }
  }

  onExists(lDispatch) {
    this.btnAnd.removeClass("is-active");
    this.btnOr.removeClass("is-active");
    this.btnExists.addClass("is-active");
    // Toglie anche la parte add term e add boolean
    this.showButton(this.btnAddBoolean, false);
    this.showButton(this.btnAddTerm, false);
    // Setta il valore
    this.node.Operator = Solr.QueryNodeBooleanType.EXISTS;
    if (lDispatch) {
      this.dispatch(QueryBuilder.EVENT_CHANGE_OPERATOR, this.node.Operator);
    }
  }

  showButton(btn, show) {
    if (show) {
      btn.css("opacity", 1);
      btn.css("pointer-events", "auto");
    } else {
      btn.css("opacity", 0);
      btn.css("pointer-events", "none");
    }
  }

  onAnd(lDispatch) {
    this.btnExists.removeClass("is-active");
    this.btnOr.removeClass("is-active");
    this.btnAnd.addClass("is-active");
    // Mostra la parte add term e add boolean
    this.showButton(this.btnAddBoolean, true);
    this.showButton(this.btnAddTerm, true);
    // Setta il valore
    this.node.Operator = Solr.QueryNodeBooleanType.AND;
    if (lDispatch) {
      this.dispatch(QueryBuilder.EVENT_CHANGE_OPERATOR, this.node.Operator);
    }
  }

  onOr(lDispatch) {
    this.btnExists.removeClass("is-active");
    this.btnAnd.removeClass("is-active");
    this.btnOr.addClass("is-active");
    // Mostra la parte add term e add boolean
    this.showButton(this.btnAddBoolean, true);
    this.showButton(this.btnAddTerm, true);
    // Setta il valore
    this.node.Operator = Solr.QueryNodeBooleanType.OR;
    if (lDispatch) {
      this.dispatch(QueryBuilder.EVENT_CHANGE_OPERATOR, this.node.Operator);
    }
  }

  onNot(lToggle) {
    if (lToggle) {
      this.node.Occurency = this.node.Occurency === Solr.QueryNodeOccurencyType.NOT ? Solr.QueryNodeOccurencyType.MUST : Solr.QueryNodeOccurencyType.NOT;
    }

    if (this.node.Occurency === Solr.QueryNodeOccurencyType.NOT) {
      this.btnNot.addClass("is-active");
    } else {
      this.btnNot.removeClass("is-active");
    }
  }

  dispatch(type, data) {
    if (this.callback) {
      this.callback({
        type,
        data,
      });
    }
  }

  buildBianca() {
    // Crea il clip
    this.mc = jQuery(this.template).clone();
    this.mc.attr("id", this.node.id);
    this.target.append(this.mc);
    this.actionsArea = this.mc.find("> .js-actions");

    if (this.node.Operator === Solr.QueryNodeBooleanType.AND) {
      jQuery(".js-panel-or", this.actionsArea).hide();
    } else {
      jQuery(".js-panel-and", this.actionsArea).hide();
    }

    /*
    // Definisce le aree
    this.actionsArea = this.mc.find("> .js-actions");
    this.buttonsArea = this.actionsArea.find("> .js-buttons");

    // Setta il path
    jQuery(".js-path", this.actionsArea).text(this.node.Field._label);

    // Per comodità definisce i pulsanti
    this.btnDelete = jQuery(".js-cta-delete", this.buttonsArea);
    this.btnAddBoolean = jQuery(".js-cta-add-boolean", this.actionsArea);
    this.btnAddTerm = jQuery(".js-cta-add-term", this.actionsArea);
    this.btnExists = jQuery(".js-cta-exists", this.actionsArea);
    this.btnAnd = jQuery(".js-cta-and", this.actionsArea);
    this.btnOr = jQuery(".js-cta-or", this.actionsArea);
    this.btnNot = jQuery(".js-cta-not", this.actionsArea);

    if (this.level === 0) {
      // Se è il nodo radice, nasconde il pulsante "rimuovi"
      this.btnDelete.hide();
      // Se è il nodo radice, nasconde il pulsante "exists"
      this.btnExists.hide();
    } else {
      // Controlla se deve mostrare il pulsante exists o no
      if (!this.node.AdmitExists) {
        this.btnExists.hide();
      }
      // Toglie la riga della collection
      this.mc.find("> .js-collection").hide();
    }

    if (this.level % 2 === 0) {
      this.mc.addClass("has-bg-light");
    }

    // Crea le call to action
    this.createActions();*/
  }
}
